var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Supplement Report")]),_c('v-data-table',{staticClass:"elevation-1 mt-5",staticStyle:{"cursor":"pointer"},attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":"client_id","hide-default-footer":"","loading":_vm.loadingTable,"loading-text":"Loading... Please wait"},on:{"click:row":_vm.handleRowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }